import React, { useState } from "react";
import { scrollBar } from "Components/Common/Header/ManageOutsideClickClose";
import { useTranslation } from "react-i18next";
import "./style.css";

interface TableProps {
  title: string;
  data: any[];
  countryUom?: any;
  onSort?: (field: string, isAsc: boolean) => void;
  orderBy?: string;
  statusIsASC?: boolean;
}

const Table: React.FC<TableProps> = ({ title, data, onSort, orderBy, statusIsASC }) => {
  const { t } = useTranslation();
  const [isScrolling, setIsScrolling] = useState<boolean>(false);

  const toggleSort = (field: string, isAcs: boolean) => {
    if (field !== "id" && onSort) {
      onSort(field, isAcs);
    }
  };

  const currentStatusIsASC = statusIsASC ?? true;

  scrollBar(setIsScrolling);
  const calculateSubtotal = () => {
    const subtotal = {
      totalFuelUse: 0,
      totalFuelUseUnit: "",
      emissionsFactor: 0,
      co2Emissions: 0,
      co2EmissionsUnit: "",
    };

    data.forEach((row) => {
      subtotal.totalFuelUse += row.totalFuelUseValue;
      subtotal.emissionsFactor += row.emissionFactor;
      subtotal.co2Emissions += row.co2EmissionsValue;
      subtotal.totalFuelUseUnit = row.totalFuelUseUnit;
      subtotal.co2EmissionsUnit = row.co2EmissionsUnit;
    });

    return subtotal;
  };

  const subtotal = calculateSubtotal();
  return (
    <div className="table-wrapper bordered-div m-4" style={{ flex: "1 1 0%", overflow: "auto", padding: "0px 24px 24px" }}>
      <h6 style={{ textAlign: "center", padding: "20px" }}>{title}</h6>
      <div
        className={`booking-list-data scroll ${
          isScrolling ? "show-scroll" : "no-scroll"
        }`}
        style={{ height: "auto" }}
      >
        <div className="table-responsive">
          <table className="display nowrap dataTable w-100">
            <thead>
              <tr>
                <th
                  className="sorting sorting_asc"
                  onClick={() => toggleSort("reporting_month", currentStatusIsASC)}
                >
                  <span>{t("Translation.reporting_month")}</span>
                </th>
                <th
                  className="sorting"
                  onClick={() => toggleSort("sub_activity", currentStatusIsASC)}
                >
                  <span>{t("Translation.sub_activity")}</span>
                </th>
                <th
                  className="sorting"
                  onClick={() => toggleSort("needed_equipment", currentStatusIsASC)}
                >
                  <span>{t("Translation.needed_equipment")}</span>
                </th>
                <th
                  className="sorting"
                  onClick={() => toggleSort("fuel_type", currentStatusIsASC)}
                >
                  <span>{t("Translation.fuel_type")}</span>
                </th>
                <th
                  className="sorting"
                  onClick={() => toggleSort("emission_factor", currentStatusIsASC)}
                >
                  <span>{t("Translation.emission_factor")}</span>
                </th>
                <th
                  className="sorting"
                  onClick={() => toggleSort("days_on_site", currentStatusIsASC)}
                >
                  <span>{t("Translation.days_on_site")}</span>
                </th>
                <th
                  className="sorting"
                  onClick={() => toggleSort("hours_use", currentStatusIsASC)}
                >
                  <span>{t("Translation.hours_use")}</span>
                </th>
                <th
                  className="sorting"
                  onClick={() => toggleSort("fuel_efficiency", currentStatusIsASC)}
                >
                  <span>{t("Translation.fuel_efficiency")}</span>
                </th>
                <th
                  className="sorting"
                  onClick={() => toggleSort("co2_emissions", currentStatusIsASC)}
                >
                  <span>{t("Translation.co2_emissions")}</span>
                </th>
                <th
                  className="sorting"
                  onClick={() => toggleSort("total_fuel_use", currentStatusIsASC)}
                >
                  <span>{t("Translation.total_fuel_use")}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  <td>{row.month}</td>
                  <td>{row.subActivity}</td>
                  <td>{row.equipmentName}</td>
                  <td>{row.fuelType}</td>
                  <td>{row.emissionFactor}</td>
                  <td>{row.daysOnSite}</td>
                  <td>{row.hoursOnSite}</td>
                  <td>{row.fuelEfficiencyPerHour}</td>
                  <td>{row.co2Emissions}</td>
                  <td>{row.totalFuelUse}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td>{t("Translation.subtotal")}</td>
                <td colSpan={7}></td>
                <td>{subtotal.co2Emissions} {subtotal.co2EmissionsUnit}</td>
                <td>{subtotal.totalFuelUse} {subtotal.totalFuelUseUnit}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Table;
